import type { $Fetch } from 'ofetch';
import type {
  ProtocoloAdminGateway, FilaProtocolosParams,
} from '@/application/port/out/ProtocoloAdminGateway';
import type { Protocolo } from '@/domain/model/Protocolo';
import type { Page } from '@/domain/model/Page';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

/**
 * HTTP gateway pra fila admin de Protocolos. Authority: acadadmin:protocolo:atender.
 *
 * @since G.5.6
 */
export class HttpProtocoloAdminGateway implements ProtocoloAdminGateway {
  constructor(private readonly client: $Fetch) {}

  async filaPorSetor(setorId: string, params: FilaProtocolosParams): Promise<Page<Protocolo>> {
    const query: Record<string, string | number> = {
      page: params.page ?? 0,
      size: params.size ?? 50,
    };
    if (params.status) query.status = params.status;
    const res = await this.client<ApiResponse<Page<Protocolo>>>(
      `/api/v1/admin/protocolos/fila/${encodeURIComponent(setorId)}`,
      { method: 'GET', params: query });
    assertApiSuccess(res);
    return res.data;
  }

  async claim(id: string): Promise<Protocolo> {
    const res = await this.client<ApiResponse<Protocolo>>(
      `/api/v1/admin/protocolos/${encodeURIComponent(id)}/claim`,
      { method: 'POST' });
    assertApiSuccess(res);
    return res.data;
  }
}
